<template>
  <v-toolbar
    class="chat-toolbar-container"
    :color="themeColor"
    height="64"
    flat>

    <template v-if="currentChatId">
      <app-avatar :id="chatUser.avatar" :size="48" :isOnline="chatUser.isOnline" />

      <div class="ml-3 mr-3">
        <div class="subheading text-no-wrap">{{chatUser.displayname}}</div>
        <dir style="display: flex; align-items: center;">
          <span class="caption">
            <template v-if="chatUser.isOnline">在線</template>
            <template v-else>離線</template>
          </span>
        </dir>
      </div>

      <v-spacer></v-spacer>

      <v-tooltip bottom v-if="!isFudaoConnected && isTeacher">
        <v-btn
          @click="openInviteFudaoDialog"
          slot="activator"
          icon>
          <v-icon>cast</v-icon>
        </v-btn>
        <span>邀請輔導</span>
      </v-tooltip>
    </template>
  </v-toolbar>
</template>

<script>
import {mapState, mapGetters} from 'vuex';

export default {
  computed: {
    ...mapState('chat', {
      currentChatId: state => state.currentChat.id
    }),

    ...mapState({
      chatUser: state => {
        let currentChatUsername = state.chat.currentChatUsername;
        return state.user.users[currentChatUsername] || {};
      }
    }),

    ...mapGetters('fudao', {
      isFudaoConnected: 'isFudaoConnected'
    })
  },

  methods: {
    openInviteFudaoDialog() {
      this.$eventBus.$emit('teacher-invite-fudao-dialog');
    }
  }
};
</script>

<style lang="stylus" scoped>

.chat-toolbar-container {
  border-bottom: 1px solid darken($secondary-color, 10%) !important;
  box-shadow: $shadow-light !important;
  z-index: 1;
}
</style>
